<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择" @change="getData">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试科目:">
          <el-select v-model="listQuery.subject_id" clearable placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 折线图 -->
    <div class="chart" id="chart">

    </div>
    <div>
      <el-table :data="tableData" stripe style="width: 100%" >
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="standardContent" label="考核点">
        </el-table-column>
        <el-table-column prop="scoreAvg" label="平均成绩">
        </el-table-column>
        <el-table-column prop="studentQuantity" label="考试人数">
        </el-table-column>
        <el-table-column prop="qualifiedPass" label="合格率">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i class="el-icon-search" @click="handleEdit(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <el-dialog title="考站成绩明细" :visible.sync="dialogTableVisible" width="80%" top="5vh">
      <el-table :data="standardDetails">
        <el-table-column label="#">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="standardContent" label="考核项">
        </el-table-column>
        <el-table-column prop="scoreAvg" label="平均成绩">
        </el-table-column>
        <el-table-column prop="studentQuantity" label="考试人数">
        </el-table-column>
        <el-table-column prop="qualifiedPass" label="通过率">
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
    export default {
        data() {
            return {
                subjectList: [],
                examList: [],
                avgdata:[],
                standardDetails:[],
                dialogTableVisible:false,
                subjectStr:[],
                studentScoreStr:[],
                scoreAvgStr:[],
                subStr:[],
                listQuery: {
                },
                tableData: []
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            this.getData();
            window.addEventListener('resize', () => {
                this.$echarts.init(document.getElementById('chart')).resize()
            })

        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },

            getData() {
                this.$http.standardAnalysis(this.listQuery)
                    .then(res => {
                        this.examList = res.data.examList;
                        this.subjectList = res.data.subjectList;
                        this.listQuery.exam_id=res.data.exam_id;
                        this.listQuery.subject_id=res.data.subject_id;
                        this.tableData = res.data.data;
                        const standardContentStr = res.data.StrList.standardContent.split(",");
                        const qualifiedPassStr = res.data.StrList.qualifiedPass.split(",");
                        this.getline(standardContentStr,qualifiedPassStr)
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                const params={
                    subject_id:this.listQuery.subject_id,
                    exam_id: this.listQuery.exam_id,
                    standard_pid:scope.pid,
                };
                this.$http.standardDetails(params).then(res=>{
                    this.standardDetails=res.data.data;
                    this.dialogTableVisible=true
                })
            },
            //构建图标
            getline(standardContentStr,qualifiedPassStr) {
                let chart = this.$echarts.init(document.getElementById('chart'))
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        orient: 'horizontal', // 'vertical'
                        x: 'right', // 'center' | 'left' | {number},
                        y: 0, // 'center' | 'bottom' | {number}
                        padding:40,
                        data: ["合格率"]
                    },
                    calculable: false,
                    xAxis: [{
                        type: "category",
                        data: standardContentStr
                    }],
                    yAxis: [{
                        type: "value",
                        axisLabel: {
                            formatter: "{value} %"
                        }
                    }],
                    series: [
                        {
                            name: "合格率",
                            type: "bar",
                            data: qualifiedPassStr
                        }]
                });
            }
        },
    };
</script>

<style scoped lang="less">

  .chart {
    width: 100%;
    height: 300px;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/standardAnalysis.vue